import api from './api';

const asError = (err, fallback = 'Request failed') => {
  const msg =
    err?.response?.data?.error ||
    err?.response?.data?.message ||
    err?.message ||
    fallback;
  return new Error(msg);
};

export const fetchTutorImports = async (params = {}) => {
  try {
    const res = await api.get('/tutor-imports', { params });
    return res.data || { items: [], total: 0, summary: {} };
  } catch (err) {
    throw asError(err, 'Failed to fetch tutor imports');
  }
};

export const fetchTutorImport = async (id) => {
  try {
    const res = await api.get(`/tutor-imports/${id}`);
    return res.data;
  } catch (err) {
    throw asError(err, 'Failed to fetch tutor import');
  }
};

export const downloadTutorImportFile = async (id, filename) => {
  try {
    const res = await api.get(`/tutor-imports/${id}/files/${encodeURIComponent(filename)}`, {
      responseType: 'blob',
    });
    return res.data;
  } catch (err) {
    throw asError(err, 'Failed to download tutor document');
  }
};

export const uploadTutorImportCsv = async ({ file, sourceName }) => {
  try {
    const form = new FormData();
    form.append('file', file);
    if (sourceName) form.append('sourceName', sourceName);
    const res = await api.post('/tutor-imports/csv', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (err) {
    throw asError(err, 'Failed to upload tutor CSV');
  }
};

export const updateTutorImportReview = async (id, payload) => {
  try {
    const res = await api.patch(`/tutor-imports/${id}`, payload);
    return res.data;
  } catch (err) {
    throw asError(err, 'Failed to update tutor import');
  }
};

export const sendTutorImportVerificationLink = async (id, payload = {}) => {
  try {
    const res = await api.post(`/tutor-imports/${id}/email-verification/send`, payload);
    return res.data;
  } catch (err) {
    throw asError(err, 'Failed to send email verification link');
  }
};
